const { REACT_APP_NODE_ENV, REACT_APP_API_URL, REACT_APP_VERSION } =
  process.env;

let testUrl,
  testUrl2,
  isDevelopment,
  rootUrl,
  envName,
  frontendVersion,
  appLabelId;

if (REACT_APP_NODE_ENV === 'production') {
  isDevelopment = false;
  testUrl = REACT_APP_API_URL;
  testUrl2 = '';
  rootUrl = 'theerpcloud.com';
  envName = '';
  frontendVersion = REACT_APP_VERSION;
  appLabelId = 4;
} else if (REACT_APP_NODE_ENV === 'staging') {
  isDevelopment = false;
  testUrl = REACT_APP_API_URL;
  testUrl2 = '';
  rootUrl = 'theerpcloud.com';
  envName = '.staging';
  frontendVersion = REACT_APP_VERSION;
  appLabelId = 4;
} else {
  // Default to development
  isDevelopment = true;
  testUrl = 'http://127.0.0.1:8000/';
  testUrl2 = 'http://localhost:3000/';
  rootUrl = 'theerpcloud.com';
  envName = '.staging';
  frontendVersion = 'development';
  appLabelId = 4;
}

const apiUrl = `${testUrl}/api/profiles/login/`;

export default {
  isDevelopment,
  api_url: apiUrl,
  test_url: testUrl,
  test_2_url: testUrl2,

  domain_url: rootUrl,
  domain_env_name: envName,
  frontend_version: frontendVersion,
  app_label_id: appLabelId,
};
